module.exports = __webpack_public_path__ + "static/media/photo1.72f87e73.jpg";